export enum EFlags {
  ad = `https://media.synctrack.io/megamind-estimated/flags/4x3/ad.svg`,

  ae = `https://media.synctrack.io/megamind-estimated/flags/4x3/ae.svg`,

  af = `https://media.synctrack.io/megamind-estimated/flags/4x3/af.svg`,

  ag = `https://media.synctrack.io/megamind-estimated/flags/4x3/ag.svg`,

  ai = `https://media.synctrack.io/megamind-estimated/flags/4x3/ai.svg`,

  al = `https://media.synctrack.io/megamind-estimated/flags/4x3/al.svg`,

  am = `https://media.synctrack.io/megamind-estimated/flags/4x3/am.svg`,

  ao = `https://media.synctrack.io/megamind-estimated/flags/4x3/ao.svg`,

  aq = `https://media.synctrack.io/megamind-estimated/flags/4x3/aq.svg`,

  ar = `https://media.synctrack.io/megamind-estimated/flags/4x3/ar.svg`,

  as = `https://media.synctrack.io/megamind-estimated/flags/4x3/as.svg`,

  at = `https://media.synctrack.io/megamind-estimated/flags/4x3/at.svg`,

  au = `https://media.synctrack.io/megamind-estimated/flags/4x3/au.svg`,

  aw = `https://media.synctrack.io/megamind-estimated/flags/4x3/aw.svg`,

  ax = `https://media.synctrack.io/megamind-estimated/flags/4x3/ax.svg`,

  az = `https://media.synctrack.io/megamind-estimated/flags/4x3/az.svg`,

  ba = `https://media.synctrack.io/megamind-estimated/flags/4x3/ba.svg`,

  bb = `https://media.synctrack.io/megamind-estimated/flags/4x3/bb.svg`,

  bd = `https://media.synctrack.io/megamind-estimated/flags/4x3/bd.svg`,

  be = `https://media.synctrack.io/megamind-estimated/flags/4x3/be.svg`,

  bf = `https://media.synctrack.io/megamind-estimated/flags/4x3/bf.svg`,

  bg = `https://media.synctrack.io/megamind-estimated/flags/4x3/bg.svg`,

  bh = `https://media.synctrack.io/megamind-estimated/flags/4x3/bh.svg`,

  bi = `https://media.synctrack.io/megamind-estimated/flags/4x3/bi.svg`,

  bj = `https://media.synctrack.io/megamind-estimated/flags/4x3/bj.svg`,

  bl = `https://media.synctrack.io/megamind-estimated/flags/4x3/bl.svg`,

  bm = `https://media.synctrack.io/megamind-estimated/flags/4x3/bm.svg`,

  bn = `https://media.synctrack.io/megamind-estimated/flags/4x3/bn.svg`,

  bo = `https://media.synctrack.io/megamind-estimated/flags/4x3/bo.svg`,

  bq = `https://media.synctrack.io/megamind-estimated/flags/4x3/bq.svg`,

  br = `https://media.synctrack.io/megamind-estimated/flags/4x3/br.svg`,

  bs = `https://media.synctrack.io/megamind-estimated/flags/4x3/bs.svg`,

  bt = `https://media.synctrack.io/megamind-estimated/flags/4x3/bt.svg`,

  bv = `https://media.synctrack.io/megamind-estimated/flags/4x3/bv.svg`,

  bw = `https://media.synctrack.io/megamind-estimated/flags/4x3/bw.svg`,

  by = `https://media.synctrack.io/megamind-estimated/flags/4x3/by.svg`,

  bz = `https://media.synctrack.io/megamind-estimated/flags/4x3/bz.svg`,

  ca = `https://media.synctrack.io/megamind-estimated/flags/4x3/ca.svg`,

  cc = `https://media.synctrack.io/megamind-estimated/flags/4x3/cc.svg`,

  cd = `https://media.synctrack.io/megamind-estimated/flags/4x3/cd.svg`,

  cf = `https://media.synctrack.io/megamind-estimated/flags/4x3/cf.svg`,

  cg = `https://media.synctrack.io/megamind-estimated/flags/4x3/cg.svg`,

  ch = `https://media.synctrack.io/megamind-estimated/flags/4x3/ch.svg`,

  ci = `https://media.synctrack.io/megamind-estimated/flags/4x3/ci.svg`,

  ck = `https://media.synctrack.io/megamind-estimated/flags/4x3/ck.svg`,

  cl = `https://media.synctrack.io/megamind-estimated/flags/4x3/cl.svg`,

  cm = `https://media.synctrack.io/megamind-estimated/flags/4x3/cm.svg`,

  cn = `https://media.synctrack.io/megamind-estimated/flags/4x3/cn.svg`,

  co = `https://media.synctrack.io/megamind-estimated/flags/4x3/co.svg`,

  cr = `https://media.synctrack.io/megamind-estimated/flags/4x3/cr.svg`,

  cu = `https://media.synctrack.io/megamind-estimated/flags/4x3/cu.svg`,

  cv = `https://media.synctrack.io/megamind-estimated/flags/4x3/cv.svg`,

  cw = `https://media.synctrack.io/megamind-estimated/flags/4x3/cw.svg`,

  cx = `https://media.synctrack.io/megamind-estimated/flags/4x3/cx.svg`,

  cy = `https://media.synctrack.io/megamind-estimated/flags/4x3/cy.svg`,

  cz = `https://media.synctrack.io/megamind-estimated/flags/4x3/cz.svg`,

  de = `https://media.synctrack.io/megamind-estimated/flags/4x3/de.svg`,

  dj = `https://media.synctrack.io/megamind-estimated/flags/4x3/dj.svg`,

  dk = `https://media.synctrack.io/megamind-estimated/flags/4x3/dk.svg`,

  dm = `https://media.synctrack.io/megamind-estimated/flags/4x3/dm.svg`,

  do = `https://media.synctrack.io/megamind-estimated/flags/4x3/do.svg`,

  dz = `https://media.synctrack.io/megamind-estimated/flags/4x3/dz.svg`,

  ec = `https://media.synctrack.io/megamind-estimated/flags/4x3/ec.svg`,

  ee = `https://media.synctrack.io/megamind-estimated/flags/4x3/ee.svg`,

  eg = `https://media.synctrack.io/megamind-estimated/flags/4x3/eg.svg`,

  eh = `https://media.synctrack.io/megamind-estimated/flags/4x3/eh.svg`,

  er = `https://media.synctrack.io/megamind-estimated/flags/4x3/er.svg`,

  'es-ct' = `https://media.synctrack.io/megamind-estimated/flags/4x3/es-ct.svg`,

  es = `https://media.synctrack.io/megamind-estimated/flags/4x3/es.svg`,

  et = `https://media.synctrack.io/megamind-estimated/flags/4x3/et.svg`,

  eu = `https://media.synctrack.io/megamind-estimated/flags/4x3/eu.svg`,

  fi = `https://media.synctrack.io/megamind-estimated/flags/4x3/fi.svg`,

  fj = `https://media.synctrack.io/megamind-estimated/flags/4x3/fj.svg`,

  fk = `https://media.synctrack.io/megamind-estimated/flags/4x3/fk.svg`,

  fm = `https://media.synctrack.io/megamind-estimated/flags/4x3/fm.svg`,

  fo = `https://media.synctrack.io/megamind-estimated/flags/4x3/fo.svg`,

  fr = `https://media.synctrack.io/megamind-estimated/flags/4x3/fr.svg`,

  ga = `https://media.synctrack.io/megamind-estimated/flags/4x3/ga.svg`,

  'gb-eng' = `https://media.synctrack.io/megamind-estimated/flags/4x3/gb-eng.svg`,

  'gb-nir' = `https://media.synctrack.io/megamind-estimated/flags/4x3/gb-nir.svg`,

  'gb-sct' = `https://media.synctrack.io/megamind-estimated/flags/4x3/gb-sct.svg`,

  'gb-wls' = `https://media.synctrack.io/megamind-estimated/flags/4x3/gb-wls.svg`,

  gb = `https://media.synctrack.io/megamind-estimated/flags/4x3/gb.svg`,

  gd = `https://media.synctrack.io/megamind-estimated/flags/4x3/gd.svg`,

  ge = `https://media.synctrack.io/megamind-estimated/flags/4x3/ge.svg`,

  gf = `https://media.synctrack.io/megamind-estimated/flags/4x3/gf.svg`,

  gg = `https://media.synctrack.io/megamind-estimated/flags/4x3/gg.svg`,

  gh = `https://media.synctrack.io/megamind-estimated/flags/4x3/gh.svg`,

  gi = `https://media.synctrack.io/megamind-estimated/flags/4x3/gi.svg`,

  gl = `https://media.synctrack.io/megamind-estimated/flags/4x3/gl.svg`,

  gm = `https://media.synctrack.io/megamind-estimated/flags/4x3/gm.svg`,

  gn = `https://media.synctrack.io/megamind-estimated/flags/4x3/gn.svg`,

  gp = `https://media.synctrack.io/megamind-estimated/flags/4x3/gp.svg`,

  gq = `https://media.synctrack.io/megamind-estimated/flags/4x3/gq.svg`,

  gr = `https://media.synctrack.io/megamind-estimated/flags/4x3/gr.svg`,

  gs = `https://media.synctrack.io/megamind-estimated/flags/4x3/gs.svg`,

  gt = `https://media.synctrack.io/megamind-estimated/flags/4x3/gt.svg`,

  gu = `https://media.synctrack.io/megamind-estimated/flags/4x3/gu.svg`,

  gw = `https://media.synctrack.io/megamind-estimated/flags/4x3/gw.svg`,

  gy = `https://media.synctrack.io/megamind-estimated/flags/4x3/gy.svg`,

  hk = `https://media.synctrack.io/megamind-estimated/flags/4x3/hk.svg`,

  hm = `https://media.synctrack.io/megamind-estimated/flags/4x3/hm.svg`,

  hn = `https://media.synctrack.io/megamind-estimated/flags/4x3/hn.svg`,

  hr = `https://media.synctrack.io/megamind-estimated/flags/4x3/hr.svg`,

  ht = `https://media.synctrack.io/megamind-estimated/flags/4x3/ht.svg`,

  hu = `https://media.synctrack.io/megamind-estimated/flags/4x3/hu.svg`,

  id = `https://media.synctrack.io/megamind-estimated/flags/4x3/id.svg`,

  ie = `https://media.synctrack.io/megamind-estimated/flags/4x3/ie.svg`,

  il = `https://media.synctrack.io/megamind-estimated/flags/4x3/il.svg`,

  im = `https://media.synctrack.io/megamind-estimated/flags/4x3/im.svg`,

  in = `https://media.synctrack.io/megamind-estimated/flags/4x3/in.svg`,

  io = `https://media.synctrack.io/megamind-estimated/flags/4x3/io.svg`,

  iq = `https://media.synctrack.io/megamind-estimated/flags/4x3/iq.svg`,

  ir = `https://media.synctrack.io/megamind-estimated/flags/4x3/ir.svg`,

  is = `https://media.synctrack.io/megamind-estimated/flags/4x3/is.svg`,

  it = `https://media.synctrack.io/megamind-estimated/flags/4x3/it.svg`,

  je = `https://media.synctrack.io/megamind-estimated/flags/4x3/je.svg`,

  jm = `https://media.synctrack.io/megamind-estimated/flags/4x3/jm.svg`,

  jo = `https://media.synctrack.io/megamind-estimated/flags/4x3/jo.svg`,

  jp = `https://media.synctrack.io/megamind-estimated/flags/4x3/jp.svg`,

  ke = `https://media.synctrack.io/megamind-estimated/flags/4x3/ke.svg`,

  kg = `https://media.synctrack.io/megamind-estimated/flags/4x3/kg.svg`,

  kh = `https://media.synctrack.io/megamind-estimated/flags/4x3/kh.svg`,

  ki = `https://media.synctrack.io/megamind-estimated/flags/4x3/ki.svg`,

  km = `https://media.synctrack.io/megamind-estimated/flags/4x3/km.svg`,

  kn = `https://media.synctrack.io/megamind-estimated/flags/4x3/kn.svg`,

  kp = `https://media.synctrack.io/megamind-estimated/flags/4x3/kp.svg`,

  kr = `https://media.synctrack.io/megamind-estimated/flags/4x3/kr.svg`,

  kw = `https://media.synctrack.io/megamind-estimated/flags/4x3/kw.svg`,

  ky = `https://media.synctrack.io/megamind-estimated/flags/4x3/ky.svg`,

  kz = `https://media.synctrack.io/megamind-estimated/flags/4x3/kz.svg`,

  la = `https://media.synctrack.io/megamind-estimated/flags/4x3/la.svg`,

  lb = `https://media.synctrack.io/megamind-estimated/flags/4x3/lb.svg`,

  lc = `https://media.synctrack.io/megamind-estimated/flags/4x3/lc.svg`,

  li = `https://media.synctrack.io/megamind-estimated/flags/4x3/li.svg`,

  lk = `https://media.synctrack.io/megamind-estimated/flags/4x3/lk.svg`,

  lr = `https://media.synctrack.io/megamind-estimated/flags/4x3/lr.svg`,

  ls = `https://media.synctrack.io/megamind-estimated/flags/4x3/ls.svg`,

  lt = `https://media.synctrack.io/megamind-estimated/flags/4x3/lt.svg`,

  lu = `https://media.synctrack.io/megamind-estimated/flags/4x3/lu.svg`,

  lv = `https://media.synctrack.io/megamind-estimated/flags/4x3/lv.svg`,

  ly = `https://media.synctrack.io/megamind-estimated/flags/4x3/ly.svg`,

  ma = `https://media.synctrack.io/megamind-estimated/flags/4x3/ma.svg`,

  mc = `https://media.synctrack.io/megamind-estimated/flags/4x3/mc.svg`,

  md = `https://media.synctrack.io/megamind-estimated/flags/4x3/md.svg`,

  me = `https://media.synctrack.io/megamind-estimated/flags/4x3/me.svg`,

  mf = `https://media.synctrack.io/megamind-estimated/flags/4x3/mf.svg`,

  mg = `https://media.synctrack.io/megamind-estimated/flags/4x3/mg.svg`,

  mh = `https://media.synctrack.io/megamind-estimated/flags/4x3/mh.svg`,

  mk = `https://media.synctrack.io/megamind-estimated/flags/4x3/mk.svg`,

  ml = `https://media.synctrack.io/megamind-estimated/flags/4x3/ml.svg`,

  mm = `https://media.synctrack.io/megamind-estimated/flags/4x3/mm.svg`,

  mn = `https://media.synctrack.io/megamind-estimated/flags/4x3/mn.svg`,

  mo = `https://media.synctrack.io/megamind-estimated/flags/4x3/mo.svg`,

  mp = `https://media.synctrack.io/megamind-estimated/flags/4x3/mp.svg`,

  mq = `https://media.synctrack.io/megamind-estimated/flags/4x3/mq.svg`,

  mr = `https://media.synctrack.io/megamind-estimated/flags/4x3/mr.svg`,

  ms = `https://media.synctrack.io/megamind-estimated/flags/4x3/ms.svg`,

  mt = `https://media.synctrack.io/megamind-estimated/flags/4x3/mt.svg`,

  mu = `https://media.synctrack.io/megamind-estimated/flags/4x3/mu.svg`,

  mv = `https://media.synctrack.io/megamind-estimated/flags/4x3/mv.svg`,

  mw = `https://media.synctrack.io/megamind-estimated/flags/4x3/mw.svg`,

  mx = `https://media.synctrack.io/megamind-estimated/flags/4x3/mx.svg`,

  my = `https://media.synctrack.io/megamind-estimated/flags/4x3/my.svg`,

  mz = `https://media.synctrack.io/megamind-estimated/flags/4x3/mz.svg`,

  na = `https://media.synctrack.io/megamind-estimated/flags/4x3/na.svg`,

  nc = `https://media.synctrack.io/megamind-estimated/flags/4x3/nc.svg`,

  ne = `https://media.synctrack.io/megamind-estimated/flags/4x3/ne.svg`,

  nf = `https://media.synctrack.io/megamind-estimated/flags/4x3/nf.svg`,

  ng = `https://media.synctrack.io/megamind-estimated/flags/4x3/ng.svg`,

  ni = `https://media.synctrack.io/megamind-estimated/flags/4x3/ni.svg`,

  nl = `https://media.synctrack.io/megamind-estimated/flags/4x3/nl.svg`,

  no = `https://media.synctrack.io/megamind-estimated/flags/4x3/no.svg`,

  np = `https://media.synctrack.io/megamind-estimated/flags/4x3/np.svg`,

  nr = `https://media.synctrack.io/megamind-estimated/flags/4x3/nr.svg`,

  nu = `https://media.synctrack.io/megamind-estimated/flags/4x3/nu.svg`,

  nz = `https://media.synctrack.io/megamind-estimated/flags/4x3/nz.svg`,

  om = `https://media.synctrack.io/megamind-estimated/flags/4x3/om.svg`,

  pa = `https://media.synctrack.io/megamind-estimated/flags/4x3/pa.svg`,

  pe = `https://media.synctrack.io/megamind-estimated/flags/4x3/pe.svg`,

  pf = `https://media.synctrack.io/megamind-estimated/flags/4x3/pf.svg`,

  pg = `https://media.synctrack.io/megamind-estimated/flags/4x3/pg.svg`,

  ph = `https://media.synctrack.io/megamind-estimated/flags/4x3/ph.svg`,

  pk = `https://media.synctrack.io/megamind-estimated/flags/4x3/pk.svg`,

  pl = `https://media.synctrack.io/megamind-estimated/flags/4x3/pl.svg`,

  pm = `https://media.synctrack.io/megamind-estimated/flags/4x3/pm.svg`,

  pn = `https://media.synctrack.io/megamind-estimated/flags/4x3/pn.svg`,

  pr = `https://media.synctrack.io/megamind-estimated/flags/4x3/pr.svg`,

  ps = `https://media.synctrack.io/megamind-estimated/flags/4x3/ps.svg`,

  pt = `https://media.synctrack.io/megamind-estimated/flags/4x3/pt.svg`,

  pw = `https://media.synctrack.io/megamind-estimated/flags/4x3/pw.svg`,

  py = `https://media.synctrack.io/megamind-estimated/flags/4x3/py.svg`,

  qa = `https://media.synctrack.io/megamind-estimated/flags/4x3/qa.svg`,

  re = `https://media.synctrack.io/megamind-estimated/flags/4x3/re.svg`,

  ro = `https://media.synctrack.io/megamind-estimated/flags/4x3/ro.svg`,

  rs = `https://media.synctrack.io/megamind-estimated/flags/4x3/rs.svg`,

  ru = `https://media.synctrack.io/megamind-estimated/flags/4x3/ru.svg`,

  rw = `https://media.synctrack.io/megamind-estimated/flags/4x3/rw.svg`,

  sa = `https://media.synctrack.io/megamind-estimated/flags/4x3/sa.svg`,

  sb = `https://media.synctrack.io/megamind-estimated/flags/4x3/sb.svg`,

  sc = `https://media.synctrack.io/megamind-estimated/flags/4x3/sc.svg`,

  sd = `https://media.synctrack.io/megamind-estimated/flags/4x3/sd.svg`,

  se = `https://media.synctrack.io/megamind-estimated/flags/4x3/se.svg`,

  sg = `https://media.synctrack.io/megamind-estimated/flags/4x3/sg.svg`,

  sh = `https://media.synctrack.io/megamind-estimated/flags/4x3/sh.svg`,

  si = `https://media.synctrack.io/megamind-estimated/flags/4x3/si.svg`,

  sj = `https://media.synctrack.io/megamind-estimated/flags/4x3/sj.svg`,

  sk = `https://media.synctrack.io/megamind-estimated/flags/4x3/sk.svg`,

  sl = `https://media.synctrack.io/megamind-estimated/flags/4x3/sl.svg`,

  sm = `https://media.synctrack.io/megamind-estimated/flags/4x3/sm.svg`,

  sn = `https://media.synctrack.io/megamind-estimated/flags/4x3/sn.svg`,

  so = `https://media.synctrack.io/megamind-estimated/flags/4x3/so.svg`,

  sr = `https://media.synctrack.io/megamind-estimated/flags/4x3/sr.svg`,

  ss = `https://media.synctrack.io/megamind-estimated/flags/4x3/ss.svg`,

  st = `https://media.synctrack.io/megamind-estimated/flags/4x3/st.svg`,

  sv = `https://media.synctrack.io/megamind-estimated/flags/4x3/sv.svg`,

  sx = `https://media.synctrack.io/megamind-estimated/flags/4x3/sx.svg`,

  sy = `https://media.synctrack.io/megamind-estimated/flags/4x3/sy.svg`,

  sz = `https://media.synctrack.io/megamind-estimated/flags/4x3/sz.svg`,

  tc = `https://media.synctrack.io/megamind-estimated/flags/4x3/tc.svg`,

  td = `https://media.synctrack.io/megamind-estimated/flags/4x3/td.svg`,

  tf = `https://media.synctrack.io/megamind-estimated/flags/4x3/tf.svg`,

  tg = `https://media.synctrack.io/megamind-estimated/flags/4x3/tg.svg`,

  th = `https://media.synctrack.io/megamind-estimated/flags/4x3/th.svg`,

  tj = `https://media.synctrack.io/megamind-estimated/flags/4x3/tj.svg`,

  tk = `https://media.synctrack.io/megamind-estimated/flags/4x3/tk.svg`,

  tl = `https://media.synctrack.io/megamind-estimated/flags/4x3/tl.svg`,

  tm = `https://media.synctrack.io/megamind-estimated/flags/4x3/tm.svg`,

  tn = `https://media.synctrack.io/megamind-estimated/flags/4x3/tn.svg`,

  to = `https://media.synctrack.io/megamind-estimated/flags/4x3/to.svg`,

  tr = `https://media.synctrack.io/megamind-estimated/flags/4x3/tr.svg`,

  tt = `https://media.synctrack.io/megamind-estimated/flags/4x3/tt.svg`,

  tv = `https://media.synctrack.io/megamind-estimated/flags/4x3/tv.svg`,

  tw = `https://media.synctrack.io/megamind-estimated/flags/4x3/tw.svg`,

  tz = `https://media.synctrack.io/megamind-estimated/flags/4x3/tz.svg`,

  ua = `https://media.synctrack.io/megamind-estimated/flags/4x3/ua.svg`,

  ug = `https://media.synctrack.io/megamind-estimated/flags/4x3/ug.svg`,

  um = `https://media.synctrack.io/megamind-estimated/flags/4x3/um.svg`,

  un = `https://media.synctrack.io/megamind-estimated/flags/4x3/un.svg`,

  us = `https://media.synctrack.io/megamind-estimated/flags/4x3/us.svg`,

  uy = `https://media.synctrack.io/megamind-estimated/flags/4x3/uy.svg`,

  uz = `https://media.synctrack.io/megamind-estimated/flags/4x3/uz.svg`,

  va = `https://media.synctrack.io/megamind-estimated/flags/4x3/va.svg`,

  vc = `https://media.synctrack.io/megamind-estimated/flags/4x3/vc.svg`,

  ve = `https://media.synctrack.io/megamind-estimated/flags/4x3/ve.svg`,

  vg = `https://media.synctrack.io/megamind-estimated/flags/4x3/vg.svg`,

  vi = `https://media.synctrack.io/megamind-estimated/flags/4x3/vi.svg`,

  vn = `https://media.synctrack.io/megamind-estimated/flags/4x3/vn.svg`,

  vu = `https://media.synctrack.io/megamind-estimated/flags/4x3/vu.svg`,

  wf = `https://media.synctrack.io/megamind-estimated/flags/4x3/wf.svg`,

  ws = `https://media.synctrack.io/megamind-estimated/flags/4x3/ws.svg`,

  xk = `https://media.synctrack.io/megamind-estimated/flags/4x3/xk.svg`,

  ye = `https://media.synctrack.io/megamind-estimated/flags/4x3/ye.svg`,

  yt = `https://media.synctrack.io/megamind-estimated/flags/4x3/yt.svg`,

  za = `https://media.synctrack.io/megamind-estimated/flags/4x3/za.svg`,

  zm = `https://media.synctrack.io/megamind-estimated/flags/4x3/zm.svg`,

  zw = `https://media.synctrack.io/megamind-estimated/flags/4x3/zw.svg`,
}
